import { Box, Spinner } from '@chakra-ui/react';
import { useState } from 'react';
import { useHistory } from 'react-router';

import { useAlert, useApi } from '@app/hooks';
import { usePermissions } from '@app/hooks/use-permissions';
import { ROLES } from '@app/navigation/types';
import Error404 from '@app/pages/errors/404';
import { useHeader } from '@app/components/common/navigation/hooks/header-service';
import { Paper } from '@app/components/common';

import { NewOutletFormInstance } from './types';
import { mapInstance } from './utils/mapInstance';
import NewOutletForm from './form';

export const CreateNewOutlet = () => {
  useHeader('Создать заявку на новую ТТ', []);

  const api = useApi();
  const history = useHistory();
  const { success, error } = useAlert();
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const canCreate = usePermissions({ roles: [ROLES.ADMIN, ROLES.CHIEF, ROLES.MANAGER, ROLES.WORKER] });


  const onFormSubmit = async (instance: Partial<NewOutletFormInstance>) => {
    setIsFetching(true);
    try {
      const response = await api.acb.createNewOutlet(mapInstance(instance));
      if (response.code === 200) {
        setIsFetching(false);
        success(response.message);

        history.push('/acl/new-outlets/');
      } else {
        setIsFetching(false);
      }
    } catch (e) {
      console.log(e);

      setIsFetching(false);
      error(e.message);
    }
  };

  const onFormCancel = () => {
    history.goBack();
  };
  if (!canCreate) {
    return <Error404 />;
  }

  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 4, lg: 12, xl: 22 }}>
      {isFetching ? (
        <Box
          width="100%"
          height="300px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Spinner />
        </Box>
      ) : (<Paper>
        <Box paddingX={4} paddingY={6}>
          <NewOutletForm
            instance={{}}
            onSubmit={onFormSubmit}
            submitText='Создать'
            onCancel={onFormCancel}
          />
        </Box>  
      </Paper>)}
    </Box>
  );
};